import {
    AlertText,
    AlertTextWrapper,
    AlertWrapper,
} from '@/src/common/components/elements/Alerts/StyledComponents'
import { faSquareXmark } from '@fortawesome/free-solid-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { ReactNode } from 'react'

const StyledErrorMessage = ({
    errorText,
    style = {},
}: {
    errorText: string | ReactNode
    style?: object
}) => {
    return (
        <AlertWrapper variant={'error'} style={style}>
            <FontAwesomeIcon icon={faSquareXmark} />
            <AlertTextWrapper>
                <AlertText>{errorText}</AlertText>
            </AlertTextWrapper>
        </AlertWrapper>
    )
}

export default StyledErrorMessage
